import { Box, Image, Text, Divider } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeProvider';

export const Footer = () => {
  const { colors } = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      display={'flex'}
      gap={5}
      flexDirection={'column'}
      marginTop={'auto'}
      width={'100%'}
      as="footer"
      bg="#f1f4f5"
      p={4}
      textAlign="center"
    >
      <Divider my={4} />
      <Box margin="auto" position={'relative'} width="150px" height={'100%'}>
        <Image width={'100%'} src="/partiu-hub-white.png" />
      </Box>
      <Box>
        <Text color="#747474" fontSize="sm">
          © Copyright 2025 -
          <span onClick={() => window.open('https://www.partiu.com.br', '_blank')} style={{ cursor: 'pointer' }}>
            {' '}
            Partiu{' '}
          </span>
          - Todos os direitos reservados
        </Text>
        <Text color="#747474" fontSize="sm">
          <span
            onClick={() => navigate('/legal/termos-de-uso')}
            style={{ cursor: 'pointer', color: colors.primaryColor || '#747474' }}
          >
            Termos de Uso
          </span>
          {'  '}e{'  '}
          <span
            onClick={() => navigate('/legal/politica-de-privacidade')}
            style={{ cursor: 'pointer', color: colors.primaryColor || '#747474' }}
          >
            Política de Privacidade
          </span>
        </Text>
      </Box>
    </Box>
  );
};
